export default "__VITE_ASSET__DlE8ci5w__"